import { Entries } from 'type-fest';
import { ArrangementFilter } from '../content/types/arrangement.filter';

export function FilterToParamsHelper(
  filterInput: { [key: string]: string | number | boolean | Array<string> },
  paramsMap: { [key: string]: string },
) {
  // Only set defined params, ignore all other params.
  return (Object.entries(paramsMap) as Entries<ArrangementFilter>).reduce<{
    [key: string]: string | number | boolean | Array<string>;
  }>((currentValue, entry) => {
    const key = entry[0];
    if (filterInput[key] === undefined) {
      return currentValue;
    }

    return { ...currentValue, [paramsMap[key]]: filterInput[key] };
  }, {});
}
